<template>
  <div class="careers-page">
    <!-- NAV -->
    <nav class="cd-nav">
      <a
        href="/home"
        class="cd-logo"
      ><img
        src="/logo.png"
        alt="TUT'TOP"
      ></a>
      <div class="cd-nav-links">
        <a href="/carrieres">{{ $t('careers.detail.allOffers') }}</a>
        <a href="/contact">{{ $t('nav.contact') }}</a>
      </div>
    </nav>

    <!-- LOADING -->
    <div
      v-if="loading"
      class="cd-loading"
    >
      <div class="cd-spinner" />
    </div>

    <!-- NOT FOUND -->
    <div
      v-else-if="!offer"
      class="cd-empty"
    >
      <h2>{{ $t('careers.detail.notFoundTitle') }}</h2>
      <p>{{ $t('careers.detail.notFoundDesc') }}</p>
      <a
        href="/carrieres"
        class="cd-btn cd-btn-primary"
      >{{ $t('careers.detail.backToOffers') }}</a>
    </div>

    <!-- DETAIL -->
    <div
      v-else
      class="cd-wrapper"
    >
      <div class="cd-back-row">
        <router-link
          to="/carrieres"
          class="cd-back"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          ><line
            x1="19"
            y1="12"
            x2="5"
            y2="12"
          /><polyline points="12 19 5 12 12 5" /></svg>
          {{ $t('careers.detail.allOffers') }}
        </router-link>
      </div>

      <div class="cd-content">
        <div class="cd-main">
          <!-- Header -->
          <div class="cd-header-card">
            <div class="cd-badge-row">
              <span
                class="cd-type-badge"
                :class="'cd-type-' + offer.type"
              >{{ typeLabel(offer.type) }}</span>
              <span class="cd-date">{{ $t('careers.detail.publishedOn') }} {{ formatDate(offer.createdAt) }}</span>
            </div>
            <h1>{{ offer.title }}</h1>
            <p class="cd-dept">
              {{ offer.department }}
            </p>
            <div class="cd-meta">
              <span class="cd-meta-item">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                ><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle
                  cx="12"
                  cy="10"
                  r="3"
                /></svg>
                {{ offer.location }}
              </span>
              <span class="cd-meta-item">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                ><circle
                  cx="12"
                  cy="12"
                  r="10"
                /><polyline points="12 6 12 12 16 14" /></svg>
                {{ offer.duration }}
              </span>
            </div>
          </div>

          <!-- Description -->
          <div class="cd-section-card">
            <h2>{{ $t('careers.detail.jobDescription') }}</h2>
            <div
              class="cd-text"
              v-html="nl2br(offer.description)"
            />
          </div>

          <!-- Requirements -->
          <div
            v-if="offer.requirements"
            class="cd-section-card"
          >
            <h2>{{ $t('careers.detail.requirements') }}</h2>
            <div
              class="cd-text"
              v-html="nl2br(offer.requirements)"
            />
          </div>

          <!-- Advantages -->
          <div
            v-if="offer.advantages"
            class="cd-section-card"
          >
            <h2>{{ $t('careers.detail.advantages') }}</h2>
            <div
              class="cd-text"
              v-html="nl2br(offer.advantages)"
            />
          </div>
        </div>

        <!-- SIDEBAR -->
        <aside class="cd-sidebar">
          <!-- APPLY CTA -->
          <div class="cd-cta-card">
            <div class="cd-cta-icon">
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#38B6FF"
                stroke-width="1.5"
              ><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
            </div>
            <h3>{{ $t('careers.detail.applyTitle') }}</h3>
            <p>{{ $t('careers.detail.applyInstructions') }} :</p>
            <a
              :href="mailtoLink"
              class="cd-email-btn"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              ><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
              contact@tuttop.io
            </a>
            <p class="cd-cta-note">
              {{ $t('careers.detail.emailSubjectNote') }}<br>
              <strong>« {{ $t('careers.detail.applicationSubjectPrefix') }} {{ offer.title }} »</strong>
            </p>
          </div>

          <!-- SOCIAL -->
          <div class="cd-social-card">
            <h3>{{ $t('careers.followUs') }}</h3>
            <div class="cd-social-links">
              <a
                href="https://www.linkedin.com/company/tut-top/"
                target="_blank"
                rel="noopener"
                class="cd-social-item"
              >
                <div class="cd-social-icon cd-linkedin">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  ><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
                </div>
                <span>LinkedIn</span>
              </a>
              <a
                href="https://www.instagram.com/its.tuttop/"
                target="_blank"
                rel="noopener"
                class="cd-social-item"
              >
                <div class="cd-social-icon cd-instagram">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  ><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" /></svg>
                </div>
                <span>Instagram</span>
              </a>
            </div>
          </div>
        </aside>
      </div>
    </div>

    <!-- FOOTER -->
    <footer class="cd-footer">
      <p>{{ $t('footer.rights') }}</p>
    </footer>
  </div>
</template>

<script>
import axios from '@/libs/axios'

export default {
  data() {
    return {
      offer: null,
      loading: true,
    }
  },
  computed: {
    mailtoLink() {
      if (!this.offer) return ''
      return `mailto:contact@tuttop.io?subject=${encodeURIComponent(`${this.$t('careers.detail.applicationSubjectPrefix')} ${this.offer.title}`)}`
    },
  },
  mounted() {
    this.fetchOffer()
  },
  methods: {
    async fetchOffer() {
      try {
        const { data } = await axios.get(`/internships/${this.$route.params.id}`)
        this.offer = data
      } catch (e) {
        this.offer = null
      } finally {
        this.loading = false
      }
    },
    typeLabel(t) {
      const key = `careers.types.${t}`
      const label = this.$t(key)
      return label === key ? t : label
    },
    formatDate(d) {
      if (!d) return ''
      const loc = this.$i18n.locale === 'fr' ? 'fr-FR' : 'en-US'
      return new Date(d).toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' })
    },
    nl2br(text) {
      if (!text) return ''
      return text.replace(/\n/g, '<br>')
    },
  },
}
</script>

<style scoped>
* { box-sizing: border-box; margin: 0; padding: 0; }
.careers-page {
  min-height: 100vh;
  background: #f0f6ff;
  font-family: 'Montserrat', 'Inter', sans-serif;
  color: #1a1a2e;
}

/* NAV */
.cd-nav {
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 40px; background: #fff; box-shadow: 0 1px 8px rgba(0,0,0,0.04);
}
.cd-nav img { height: 42px; }
.cd-nav-links { display: flex; gap: 24px; }
.cd-nav-links a { color: #64748b; text-decoration: none; font-size: 0.88rem; font-weight: 600; transition: color 0.2s; }
.cd-nav-links a:hover { color: #38B6FF; }

/* LOADING / EMPTY */
.cd-loading, .cd-empty { text-align: center; padding: 120px 20px; }
.cd-spinner {
  width: 36px; height: 36px; border: 3px solid #e0e7ef; border-top-color: #38B6FF;
  border-radius: 50%; animation: spin 0.7s linear infinite; margin: 0 auto;
}
@keyframes spin { to { transform: rotate(360deg); } }
.cd-empty h2 { margin-bottom: 8px; }
.cd-empty p { color: #64748b; margin-bottom: 20px; }

/* WRAPPER */
.cd-wrapper { max-width: 1100px; margin: 0 auto; padding: 32px 24px; }
.cd-back-row { margin-bottom: 24px; }
.cd-back {
  display: inline-flex; align-items: center; gap: 6px;
  color: #64748b; text-decoration: none; font-size: 0.88rem; font-weight: 600;
  transition: color 0.2s;
}
.cd-back:hover { color: #38B6FF; }

.cd-content { display: grid; grid-template-columns: 1fr 360px; gap: 28px; align-items: start; }

/* MAIN */
.cd-main { display: flex; flex-direction: column; gap: 20px; }
.cd-header-card, .cd-section-card {
  background: #fff; border-radius: 14px; padding: 28px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.cd-badge-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.cd-type-badge { padding: 5px 14px; border-radius: 20px; font-size: 0.78rem; font-weight: 600; }
.cd-type-pfe { background: #fce4ec; color: #c62828; }
.cd-type-stage_2_mois { background: #e8f6ff; color: #0884D0; }
.cd-type-stage_4_mois { background: #e3f2fd; color: #1565c0; }
.cd-type-stage { background: #e8f6ff; color: #0884D0; }
.cd-type-cdd { background: #fff8e1; color: #f57f17; }
.cd-type-cdi { background: #e8fff0; color: #28c76f; }
.cd-type-alternance { background: #fff3e0; color: #e65100; }
.cd-type-freelance { background: #f3e8ff; color: #7c3aed; }
.cd-date { font-size: 0.8rem; color: #9ca3af; }
.cd-header-card h1 { font-size: 1.6rem; font-weight: 800; margin-bottom: 6px; }
.cd-dept { color: #64748b; font-size: 0.95rem; margin-bottom: 16px; }
.cd-meta { display: flex; gap: 20px; }
.cd-meta-item {
  display: flex; align-items: center; gap: 6px;
  font-size: 0.88rem; color: #64748b;
}
.cd-section-card h2 { font-size: 1.1rem; font-weight: 700; margin-bottom: 14px; color: #1a1a2e; }
.cd-text { font-size: 0.92rem; line-height: 1.7; color: #475569; }

/* SIDEBAR */
.cd-sidebar { display: flex; flex-direction: column; gap: 20px; position: sticky; top: 24px; }
.cd-cta-card {
  background: #fff; border-radius: 14px; padding: 28px; text-align: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 2px solid #e8f6ff;
}
.cd-cta-icon { margin-bottom: 12px; }
.cd-cta-card h3 { font-size: 1.15rem; font-weight: 700; margin-bottom: 10px; }
.cd-cta-card > p { font-size: 0.88rem; color: #64748b; line-height: 1.5; margin-bottom: 16px; }
.cd-email-btn {
  display: inline-flex; align-items: center; gap: 8px;
  background: linear-gradient(135deg, #38B6FF, #0884D0); color: #fff;
  padding: 12px 24px; border-radius: 10px; text-decoration: none;
  font-size: 0.92rem; font-weight: 700; transition: all 0.25s; margin-bottom: 16px;
}
.cd-email-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(56,182,255,0.35); }
.cd-cta-note { font-size: 0.82rem; color: #9ca3af; line-height: 1.5; }
.cd-cta-note strong { color: #1a1a2e; }

.cd-social-card {
  background: #fff; border-radius: 14px; padding: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.cd-social-card h3 { font-size: 0.95rem; font-weight: 700; margin-bottom: 14px; }
.cd-social-links { display: flex; flex-direction: column; gap: 10px; }
.cd-social-item {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 14px; border-radius: 10px; text-decoration: none;
  color: #1a1a2e; font-size: 0.88rem; font-weight: 600;
  transition: background 0.2s;
}
.cd-social-item:hover { background: #f0f6ff; }
.cd-social-icon {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; color: #fff;
}
.cd-linkedin { background: #0077B5; }
.cd-instagram { background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888); }

/* BTN */
.cd-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 10px 24px; border: none; border-radius: 10px;
  font-size: 0.9rem; font-weight: 600; cursor: pointer; text-decoration: none; transition: all 0.2s;
}
.cd-btn-primary { background: linear-gradient(135deg, #38B6FF, #0884D0); color: #fff; }
.cd-btn-primary:hover { transform: translateY(-1px); box-shadow: 0 4px 16px rgba(56,182,255,0.35); }

/* FOOTER */
.cd-footer {
  text-align: center; padding: 24px;
  border-top: 1px solid #e0e7ef; margin-top: 40px;
}
.cd-footer p { color: #9ca3af; font-size: 0.8rem; }

@media (max-width: 860px) {
  .cd-content { grid-template-columns: 1fr; }
  .cd-sidebar { position: static; }
  .cd-nav { padding: 10px 16px; }
  .cd-nav img { height: 36px; }
  .cd-header-card h1 { font-size: 1.3rem; }
}
</style>
